import { Button } from '@/components/ui/Button';
import Modal from '@/components/Modal';

const CoinGiftModal = ({
    isVisible,
    image,
    title,
    description,
    buttonLabel,
    onButtonClick,
    onClose
}) => {
    return (
        <Modal isVisible={isVisible} onClose={onClose} closeable={true}>
            <div className="modal-container">
                <img src={image} className="modal-image" />

                <span className={`modal-title`}>{title}</span>
                <span className={`modal-description`}>{description}</span>

                <div className={`modal-button-container`}>
                    <Button className={`modal-button`} onClick={onButtonClick}>
                        {buttonLabel}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default CoinGiftModal;
